const QUICK_BUY_URLS = {
  bullx:
    "https://bullx.io/terminal?chainId=1399811149&address=TOKEN_ADDRESS&r=C3LVHRVFOA9",
  "bullx-neo":
    "https://neo.bullx.io/terminal?chainId=1399811149&address=TOKEN_ADDRESS&r=C3LVHRVFOA9",
  dexscreener: "https://dexscreener.com/solana/TOKEN_ADDRESS",
  gmgn: "https://gmgn.ai/sol/token/d8VCloCU_TOKEN_ADDRESS",
  jupiter:
    "https://jup.ag/swap/So11111111111111111111111111111111111111112-TOKEN_ADDRESS",
  nova: "https://t.me/TradeonNovaBot?start=r-radarfun-TOKEN_ADDRESS",
  photon: "https://photon-sol.tinyastro.io/en/r/@radarfun/TOKEN_ADDRESS",
  trojan: "https://t.me/solana_trojanbot?start=r-radarfun-TOKEN_ADDRESS",
  bloom: "https://t.me/BloomSolana_bot?start=ref_radarfun_ca_TOKEN_ADDRESS",
  outlight: "https://t.me/LightDealerBot?start=outlightfun-token-TOKEN_ADDRESS",
};

export const getQuickBuyUrl = (tokenAddress, user) => {
  const preference = user?.quick_buy_preference || "outlight";
  const baseUrl = QUICK_BUY_URLS[preference];

  if (!baseUrl || !tokenAddress) return "#";

  return baseUrl.replace("TOKEN_ADDRESS", tokenAddress);
};
